'use strict';
const {toOptionalPositiveInteger} = require('../../react/services/Utilities.ts');

(function() {
  const module = angular.module('client.components');

  controller.$inject = [
    '$scope',
    '$location',
    '$route',
    '$log',
    'ModalNavigation',
    'ActiveMode',
    'ModalService',
    'userPermissions',
    'userClassPermissions',
    'PermissionConsts',
    'User',
    'ExperienceNavigator',
    'tourService',
    'CourseFactory',
    'LicensePlans'
  ];

  function controller($scope, $location, $route, $log, ModalNavigation, ActiveMode, ModalService, userPermissions, userClassPermissions, PermissionConsts, User, ExperienceNavigator, tourService, CourseFactory, LicensePlans) {
    const ctrl = this;

    ctrl.userId = User.getId();
    const routeClassId = $route.current && $route.current.params && $route.current.params.classId;
    const normalizedClassId = toOptionalPositiveInteger(routeClassId) ?? null;
    ctrl.classId = normalizedClassId;
    const routeCurrentCourse = $route.current && $route.current.locals && $route.current.locals.currentCourse;
    const hasClassRoute = normalizedClassId !== null;
    ctrl.showManageCollections = hasClassRoute;
    ctrl.assignExperienceText = hasClassRoute ? '' : 'Assign an Experience to one or more classes';

    function setAssignExperienceText(course) {
      const className = course && (course.custom_name || course.class_name);
      if (!className) {
        return false;
      }

      ctrl.assignExperienceText = 'Assign an Experience to ' + className;
      return true;
    }

    if (hasClassRoute) {
      if (!routeCurrentCourse || !setAssignExperienceText(routeCurrentCourse)) {
        CourseFactory.get(ctrl.classId)
          .then(setAssignExperienceText)
          .catch(function(error) {
            $log.error('Unable to load class name for Library heading.', error);
          });
      }
    }
    let licenseToAssignQueue = Promise.resolve();

    ctrl.onAssignClick = function(params) {
      $scope.$apply(function() {
        const templateId = params.templateId;
        const parents = params.parents;
        const inClassMode = ActiveMode.isClassMode();
        const classId = ctrl.classId;

        if (!inClassMode && !userPermissions.hasPermission(PermissionConsts.add_multi_class_experience)) {
          ModalService.show({
            feature: 'add_multi_class_experience',
            template: require('../../views/partials/modals/subscriptionFeatureModal.jade'),
            backdrop: 'static'
          });
          return;
        }

        const navParams = {
          templateId: templateId,
          parents: parents,
          is_public: params.isPublic
        };

        if (inClassMode && classId) {
          ModalNavigation.navigateToModalWithParam('/class/' + classId + '/assign', navParams, $location.path());
        } else {
          ModalNavigation.navigateToModalWithParam('/experience/assign', navParams, $location.path());
        }
      });
    };

    function getLicenseId(license) {
      return Number(license && (license.subscription_id || license.id));
    }

    function showLicenseError(message) {
      ModalService.show({
        message: message,
        backdrop: 'static',
        buttons: [
          {
            title: 'Ok',
            click: '$hide();'
          }
        ]
      });
    }

    function getSelectedLicenses(course, assignableLicenses, selectedLicenseId) {
      // Class data contains subscription rows; class save expects matching assignable license plan rows.
      const selectedLicenseIds = (course.licenses || []).map(getLicenseId);

      if (selectedLicenseIds.indexOf(selectedLicenseId) === -1) {
        selectedLicenseIds.push(selectedLicenseId);
      }

      return assignableLicenses.filter(function(license) {
        return selectedLicenseIds.indexOf(getLicenseId(license)) !== -1;
      });
    }

    function saveClassLicense(course, licenses) {
      const params = {
        cid: course.cid,
        class_name: course.class_name,
        custom_name: course.custom_name,
        grade: course.grade,
        subject: course.subject,
        licenses: licenses,
        settings: course.settings
      };

      return CourseFactory.update(params).then(function(updatedCourse) {
        userClassPermissions.resetPermissions(ctrl.userId, ctrl.classId);
        return updatedCourse;
      });
    }

    function licenseClassForSelectedExperience(params) {
      const licenseId = Number(params && params.licenseId);

      if (!ctrl.classId || !Number.isFinite(licenseId)) {
        showLicenseError('Unable to license this class for the selected experience.');
        return null;
      }

      return CourseFactory.get(ctrl.classId)
        .then(function(course) {
          return LicensePlans.getAssignable({userId: ctrl.userId}).$promise
            .then(function(assignableLicenses) {
              const matchingLicense = (assignableLicenses || []).find(function(license) {
                return getLicenseId(license) === licenseId;
              });

              if (!matchingLicense) {
                showLicenseError('The selected license is no longer available.');
                return null;
              }

              const selectedLicenses = getSelectedLicenses(course, assignableLicenses || [], licenseId);
              return saveClassLicense(course, selectedLicenses);
            });
        })
        .catch(function(error) {
          $log.error('Unable to license this class for the selected experience.', error);
          showLicenseError('Unable to license this class for the selected experience.');
          throw error;
        });
    }

    ctrl.onLicenseToAssignClick = function(params) {
      return $scope.$apply(function() {
        const queuedLicenseToAssign = licenseToAssignQueue
          .catch(function() {
            return null;
          })
          .then(function() {
            return licenseClassForSelectedExperience(params);
          });

        licenseToAssignQueue = queuedLicenseToAssign;
        return queuedLicenseToAssign;
      });
    };

    ctrl.onNavigateToExperience = function(params) {
      $scope.$apply(function() {
        tourService.gotoNextTourStep();
        const experienceId = params.experienceId;
        const classId = params.classId;
        const location = '/experience/' + experienceId + '/activity/scene/0';
        const back = classId ? '/class/' + classId + '/library' : '/experience/library';
        if (!tourService.isTouring()) {
          ExperienceNavigator.setPreview(true);
        }
        ExperienceNavigator.navigateToExperience(location, "", back);
      });
    };
  }

  module.component('xpLibrary', {
    template: require('./library.jade'),
    controller: controller,
  });
})();
